.al{max-width:100%;}